export default "__VITE_PUBLIC_ASSET__7ec87016__"